'use client';

import {
	GridToolbarColumnsButton,
	GridToolbarContainer,
	GridToolbarDensitySelector,
	GridToolbarFilterButton,
} from '@mui/x-data-grid-premium';
import React from 'react';

interface CustomToolbarProps {
	customAction?: React.JSX.Element | React.JSX.Element[];
	otherItems?: React.JSX.Element | React.JSX.Element[];
}

export const CustomToolbar = ({ otherItems, customAction }: CustomToolbarProps) => (
	<GridToolbarContainer>
		<GridToolbarFilterButton data-cy='filter-table-button' />
		<GridToolbarColumnsButton />
		<GridToolbarDensitySelector />
		{otherItems}
		{customAction}
	</GridToolbarContainer>
);
